import { createAction } from 'redux-actions';
import { isSSOAuthSupported, isUserOsMacos } from '../../utils';

export const checkDeviceSSOAuthSupport: any = createAction('device/CHECK_DEVICE_SSO_AUTH_SUPPORT', () => () =>
  isSSOAuthSupported()
);

export const checkIsUserOsMacos: any = createAction('device/CHECK_IS_USER_OS_MACOS', () => () => isUserOsMacos());
